import { defineMessages } from 'react-intl';

export const messages: {
	createSpaceButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	chatInputActionsButtonsTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	mentionTypeAheadButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	linkTypeAheadButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	addContentButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	addMoreFormattingButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deepResearchButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deepResearchButtonAgentMentionDisabledTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	addCurrentPageAsContextDisabledTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	discoverSkillsButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	discoverSkillsButtonDisabledTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	discoverSkillsButtonAgentMentionDisabledTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	browsePromptLibraryButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	browsePromptLibraryNewBadge: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	createSpaceButtonLabel: {
		id: 'ai-mate.chat-input.create-space-button.label',
		defaultMessage: 'Create space',
		description: 'Label for the create space button in the chat input actions menu',
	},
	chatInputActionsButtonsTooltip: {
		id: 'ai-mate.chat-input.open-chat-input-buttons-tooltip',
		defaultMessage: 'Add',
		description: 'Tooltip for Add a resource menu button',
	},
	mentionTypeAheadButtonLabel: {
		id: 'ai-mate.chat-input.mention-type-ahead-button.label',
		defaultMessage: 'Mention someone',
		description: 'Label for the mention type ahead button',
	},
	linkTypeAheadButtonLabel: {
		id: 'ai-mate.chat-input.link-type-ahead-button.label',
		defaultMessage: 'Add a link',
		description: 'Label for the link type ahead button',
	},
	addContentButtonLabel: {
		id: 'ai-mate.chat-input.add-content-button.label',
		defaultMessage: "Use what you're viewing as context",
		description: 'Label for the add current page as context button',
	},
	addMoreFormattingButtonLabel: {
		id: 'ai-mate.chat-input.add-more-formatting-button.label',
		defaultMessage: 'More formatting',
		description: 'Label for the more formatting button',
	},
	deepResearchButtonLabel: {
		id: 'ai-mate.chat-input.deep-research-button.label',
		defaultMessage: 'Deep research',
		description: 'Label for the deep research button in the chat input actions menu',
	},
	deepResearchButtonAgentMentionDisabledTooltip: {
		id: 'ai-mate.chat-input.deep-research-button.agent-mention-disabled-tooltip',
		defaultMessage: 'Not available with mentioned agents',
		description:
			'Tooltip for the deep research button when disabled because an agent is @-mentioned in the chat input',
	},
	addCurrentPageAsContextDisabledTooltip: {
		id: 'ai-mate.chat-input.add-current-page-as-context-disabled-tooltip',
		defaultMessage: "This page isn't supported yet",
		description: 'Tooltip for the add current page as context button when disabled',
	},
	discoverSkillsButtonLabel: {
		id: 'ai-mate.chat-input.discover-skills-button.label',
		defaultMessage: 'View all skills',
		description: 'Label for the view all skills button',
	},
	discoverSkillsButtonDisabledTooltip: {
		id: 'ai-mate.chat-input.discover-skills-button.disabled-tooltip',
		defaultMessage: "You're already using a skill",
		description:
			'Tooltip for the discover skills button when disabled because a skill is already in the prompt',
	},
	discoverSkillsButtonAgentMentionDisabledTooltip: {
		id: 'ai-mate.chat-input.discover-skills-button.agent-mention-disabled-tooltip',
		defaultMessage: 'Not available with mentioned agents',
		description:
			'Tooltip for the discover skills button when disabled because an agent is @-mentioned in the chat input',
	},
	browsePromptLibraryButtonLabel: {
		id: 'ai-mate.chat-input.browse-prompt-library-button.label',
		defaultMessage: 'Browse prompt library',
		description: 'Label for the browse prompt library button',
	},
	browsePromptLibraryNewBadge: {
		id: 'ai-mate.chat-input.browse-prompt-library-button.new-badge',
		defaultMessage: 'New',
		description: 'New badge label for the browse prompt library button',
	},
});
